import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

export const MAX_GLASS_CHECKLIST_FILES = 10;

const uploadGlassChecklistFile = async (file) => {
  const renamedFile = new File(
    [new Blob([file], { type: file.type })],
    `glass-checklist-performed-${file.name}`,
    { type: file.type },
  );
  const formData = new FormData();
  formData.append('file', renamedFile);

  const response = await axios.post(`${API_URL}/bulk/upload`, formData, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
  const uuid = response.data?.uuid;
  if (!uuid) {
    throw new Error('Upload response missing uuid');
  }
  return uuid;
};

export const uploadGlassChecklistFiles = (files) =>
  Promise.all(files.map(uploadGlassChecklistFile));
